import { QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";

import customHistory from "@routing/history";
import HistoryRouter from "@routing/HistoryRouter";

import theme from "@theme/index";

import App from "./App";
import C from "./constants/constants";
import queryClient from "./queryClient";
import reportWebVitals from "./reportWebVitals";

import "./index.css";

LicenseInfo.setLicenseKey(C.VITE_APP_MUI_LICENSE_KEY);

const rootElement = document.querySelector("#root");
if (rootElement === null) {
  throw new Error("No element with id 'root'");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
  <HistoryRouter history={customHistory}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </HistoryRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
